/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionAnswer
 */
export interface SectionAnswer {
    /**
     * 
     * @type {number}
     * @memberof SectionAnswer
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SectionAnswer
     */
    text?: string;
}

export function SectionAnswerFromJSON(json: any): SectionAnswer {
    return SectionAnswerFromJSONTyped(json, false);
}

export function SectionAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function SectionAnswerToJSON(value?: SectionAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
    };
}


